import {
  triggerEnhancedWebviewFeature,
  isEnhancedWebviewFeatureSupported,
} from '@buzzfeed/bf-utils/lib/webview';

/**
 * Check if the native `scrollDisabled` enhanced webview action is supported.
 */
const isSupported = () =>
  isEnhancedWebviewFeatureSupported({ action: 'scrollDisabled', version: 1 });

/**
 * Set of keys currently requesting that native scrolling be disabled.
 * Multiple UI elements (share tray, overflow "More options" menu, etc.)
 * can independently ask for scroll to be disabled; native scroll is only
 * re-enabled once every key has been released.
 */
const disabledKeys = new Set();
let lastSentIsDisabled = false;

const sendNativeScrollDisabled = (isDisabled) => {
  if (typeof window === 'undefined' || !isSupported()) return;
  if (isDisabled === lastSentIsDisabled) return;
  lastSentIsDisabled = isDisabled;
  triggerEnhancedWebviewFeature({
    action: 'scrollDisabled',
    params: { isDisabled },
    version: 1,
  });
};

/**
 * Request native scroll to be disabled or re-enabled on behalf of a
 * specific UI element identified by `key`. Native scroll stays disabled
 * as long as at least one key is requesting it.
 *
 * No-op when the native host does not support the action.
 */
export const setNativeScrollDisabledByKey = (key, isDisabled) => {
  if (isDisabled) {
    disabledKeys.add(key);
  } else {
    disabledKeys.delete(key);
  }
  sendNativeScrollDisabled(disabledKeys.size > 0);
};

/**
 * Single-source convenience wrapper. Equivalent to using a dedicated
 * key called 'default'.
 */
export const setNativeScrollDisabled = (isDisabled) => {
  setNativeScrollDisabledByKey('default', isDisabled);
};
